import { COMMENT_FETCH_SIZE } from '~/features/comment/useGetCommentListQuery';
import {
  CommentSort,
  CreateCommentRequest,
  DeleteCommentRequest,
  DeleteEmojiRequest,
  EditCommentRequest,
  GetCommentRequest,
  GetCommentsResponse,
  LikeCommentRequest,
  PaginationRequest,
  PostEmojiRequest,
  EmptyResponse,
} from '~/types';
import { fetcher } from './config/fetcher';
import http from './config/http';

export const getCommentList = async ({
  character_id,
  page,
  sort_by,
}: PaginationRequest<GetCommentRequest> & {
  sort_by: CommentSort;
}) => {
  return fetcher(() =>
    http.get<GetCommentsResponse>(
      // `/character/commentList?sort_by=${sort_by}&page=${page}&page_size=${COMMENT_FETCH_SIZE}`,
      `/characters/${character_id}/comments`,
      {
        params: {
          page,
          page_size: COMMENT_FETCH_SIZE,
          sort_by,
        },
      },
    ),
  );
};

export const createComment = async ({
  character_id,
  content,
}: CreateCommentRequest) => {
  return fetcher(() =>
    http.post<EmptyResponse>(`/characters/${character_id}/comments`, {
      content,
    }),
  );
};

export const editComment = async ({
  character_id,
  comment_id,
  ...request
}: EditCommentRequest) => {
  return fetcher(() =>
    http.put<EmptyResponse>(
      `/characters/${character_id}/comments/${comment_id}`,
      request,
    ),
  );
};

export const deleteComment = async ({
  character_id,
  comment_id,
}: DeleteCommentRequest) => {
  return fetcher(() =>
    http.delete<EmptyResponse>(
      `/characters/${character_id}/comments/${comment_id}`,
    ),
  );
};

export const likeComment = async ({
  character_id,
  comment_id,
}: LikeCommentRequest) => {
  return fetcher(() =>
    http.post<EmptyResponse>(
      `/characters/${character_id}/comments/${comment_id}/likes`,
    ),
  );
};

export const unlikeComment = async ({
  character_id,
  comment_id,
}: LikeCommentRequest) => {
  return fetcher(() =>
    http.delete<EmptyResponse>(
      `/characters/${character_id}/comments/${comment_id}/likes`,
    ),
  );
};

export const postEmoji = async ({
  character_id,
  emoji_id,
}: PostEmojiRequest) => {
  return fetcher(() =>
    http.post<EmptyResponse>(`/characters/${character_id}/emojis/${emoji_id}`),
  );
};

export const deleteEmoji = async ({
  character_id,
  emoji_id,
}: DeleteEmojiRequest) => {
  return fetcher(() =>
    http.delete<EmptyResponse>(
      `/characters/${character_id}/emojis/${emoji_id}`,
    ),
  );
};
